<template>
  <div class="bg-black min-h-screen overflow-y-auto">
    <LoadingScreen />
    <Toast />
    <router-view></router-view>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import LoadingScreen from './components/loading-screen.vue';
import Toast from './components/toast.vue';

// Ensure dark mode is enabled on app startup
onMounted(() => {
  const htmlElement = document.documentElement;
  if (!htmlElement.classList.contains('dark')) {
    htmlElement.classList.add('dark');
  }
});
</script>

<style lang="scss" scoped></style>